import MobileUploadChannel from "../channels/mobile_upload_channel"

$(document).on('click', '.upload-from-phone-btn', function() {
  const $currentModal = $(this).closest('.modal');

  // If button is inside a modal
  if ($currentModal.length) {
    $currentModal.modal('hide');
  }

  var btn = $(this);
  var uploadableType = btn.data('uploadable-type');
  var uploadableId = btn.data('uploadable-id');
  var questionnaireId = btn.data('questionnaire-id');
  var questionType = btn.data('question-type');
  var refreshType = btn.data('refresh-type') || 'questionnaire';

  $.ajax({
    url: '/mobile_upload_sessions',
    method: 'POST',
    data: {
      uploadable_type: uploadableType,
      uploadable_id: uploadableId,
      question_type: questionType
    },
    success: function(res) {
      $('#mobileUploadModal .modal-body .qr-code-container').html(res.qr_code_svg);
      $('#mobileUploadModal .modal-body .qr-code-link').html(res.qr_code_url);
      $('#mobileUploadModal').modal('show');

      subscribeToMobileUploadChannel(res, btn, questionnaireId, refreshType);
      unsubscribeAfterDelay(res);
    }
  });
});

function subscribeToMobileUploadChannel(res, btn, questionnaireId, refreshType) {
  // Subscribe to ActionCable
  MobileUploadChannel.subscribe(res.uuid, {
    onFilesUploaded: function(data) {
      $('#mobileUploadModal').modal('hide');

      if (refreshType === 'questionnaire') {
        handleQuestionnaireFormUpload(btn, questionnaireId);
      } else if (refreshType === 'applicant-form') {
        handleApplicantFormUpload(res, btn);
      } else if (refreshType === 'project-folder-upload') {
        window.location.reload();
      }
    }
  });
}

function handleQuestionnaireFormUpload(btn, questionnaireId) {
  $.ajax({
    url: '/v2/project_questionnaires/' + questionnaireId + '/fetch_files',
    method: 'GET',
    success: function(html) {
      $('#files-display-' + questionnaireId).html(html);
      $(btn).parents('.document-form-card').attr('data-files-present', 'true');
    }
  });
}

function handleApplicantFormUpload(res, btn) {
  var hiddenSessionTargetClass = btn.data('hidden-target-class');
  var hiddenSessionIdsInput = btn.parents('.row').find('.' + hiddenSessionTargetClass);
  var fileDisplaySection = btn.siblings('.files-display-section')

  if (hiddenSessionIdsInput.length > 0) {
    var sessionIds = hiddenSessionIdsInput.val();
    if (sessionIds.length === 0) {
      sessionIds = [];
    } else if (sessionIds.includes(res.uuid)) {
      return;
    } else {
      sessionIds = sessionIds.split(',');
    }
    var newSessionId = res.uuid;
    sessionIds.push(newSessionId);
    hiddenSessionIdsInput.val(sessionIds.join(','));

    if (sessionIds.length > 0) {
      $(hiddenSessionIdsInput).siblings('.requiredField').attr('data-files-present', 'true');
    }

    $.ajax({
      url: '/mobile_upload_sessions/fetch_files',
      method: 'GET',
      data: { session_ids: sessionIds },
      success: function(html) {
        $(fileDisplaySection).html(html);
      },
      error: function(xhr, status, error) {
        console.error('Error fetching files:', error);
      }
    });
  }
}

function unsubscribeAfterDelay(res) {
  var delay = res.expires_in_seconds * 1000
  setTimeout(function() {
    MobileUploadChannel.unsubscribe(res.uuid);
  }, delay);
}
